var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Title',{attrs:{"title-text":_vm.$t('changePasswordForm_change_text'),"text":("" + (_vm.$t('changePassword_both_text'))),"data-qa":"por-change--title"}}),_c('ChangePasswordForm',{attrs:{"data-qa":"change-password-form"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }